import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import GameAdminCore from './GameAdminCore';

const API = process.env.REACT_APP_API_BASE || '';

export default function GameAdminByGroup() {
  const { groupSlug } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    let cancel = false;
    (async () => {
      setErr('');
      setData(null);
      try {
        const r = await fetch(`${API}/api/game/control-groups/by-slug/${encodeURIComponent(groupSlug)}`);
        const j = await r.json().catch(() => ({}));
        if (!r.ok) {
          if (!cancel) setErr(j.error === 'not_found' ? '找不到此群組' : (j.message || j.error || '載入失敗'));
          return;
        }
        if (!cancel) setData(j);
      } catch {
        if (!cancel) setErr('網路錯誤');
      }
    })();
    return () => { cancel = true; };
  }, [groupSlug]);

  if (err) {
    return (
      <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif', fontWeight: 800 }}>
        {err}
      </div>
    );
  }
  if (!data) {
    return (
      <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif', fontWeight: 800 }}>
        載入中…
      </div>
    );
  }

  const title = data.displayName ? `${data.displayName}` : `小幫手｜${data.slug}`;
  return (
    <GameAdminCore
      helperMode
      allowedIds={data.teamIds || []}
      title={title}
    />
  );
}
